import api from "./api";

function buildPlatformTenantConfig(options = {}) {
  const platformTenantId = String(options?.platformTenantId || "").trim();
  if (!platformTenantId) return {};
  return {
    headers: {
      "x-platform-tenant-id": platformTenantId,
    },
  };
}

export const TECHNICAL_ASSET_TYPE_OPTIONS = [
  { value: "main_distributor", label: "Hoofdverdeler" },
  { value: "sub_distributor", label: "Subverdeler" },
  { value: "distribution_board", label: "Verdeelkast" },
  { value: "main_distribution_board", label: "Hoofdverdelerkast" },
  { value: "sub_distribution_board", label: "Onderverdelerkast" },
  { value: "fire_alarm_panel", label: "BMI-centrale" },
  { value: "oai_panel", label: "OAI-paneel" },
  { value: "power_supply", label: "Voeding" },
  { value: "loop", label: "Loop" },
  { value: "group", label: "Groep" },
  { value: "module", label: "Module" },
  { value: "door_controller", label: "Deurcontroller" },
  { value: "sensor", label: "Sensor" },
  { value: "external_link", label: "Externe koppeling" },
  { value: "generic", label: "Algemeen" },
];

export const TECHNICAL_INSTALLATION_TYPE_OPTIONS = [
  { value: "electrical", label: "Elektra" },
  { value: "fire_alarm", label: "BMI" },
  { value: "evacuation_alarm", label: "OAI" },
  { value: "emergency_lighting", label: "Noodverlichting" },
  { value: "sprinkler", label: "Sprinkler" },
  { value: "gas_suppression", label: "Blusgas" },
  { value: "security", label: "Security" },
  { value: "data", label: "Data" },
  { value: "mechanical", label: "Mechanisch" },
  { value: "other", label: "Overig" },
];

export const TECHNICAL_ASSET_INSTALLATION_TYPE_OPTIONS = [
  { value: "electra", label: "Elektra" },
  { value: "bmi", label: "BMI" },
  { value: "oai", label: "OAI" },
  { value: "security", label: "Security" },
  { value: "data", label: "Data" },
  { value: "mechanical", label: "Mechanisch" },
  { value: "mixed", label: "Gemengd" },
  { value: "other", label: "Overig" },
];

export const TECHNICAL_ASSET_STATUS_OPTIONS = [
  { value: "concept", label: "Concept" },
  { value: "active", label: "Actief" },
  { value: "inactive", label: "Inactief" },
  { value: "fault", label: "Storing" },
  { value: "maintenance", label: "Onderhoud" },
  { value: "decommissioned", label: "Uit bedrijf" },
];

export const TECHNICAL_CONNECTION_TYPE_OPTIONS = [
  { value: "power", label: "Voeding" },
  { value: "electrical_group", label: "Elektragroep" },
  { value: "bmi_loop", label: "BMI-loop" },
  { value: "oai_zone", label: "OAI-zone" },
  { value: "control", label: "Besturing" },
  { value: "signal", label: "Signaal" },
  { value: "data_network", label: "Datanetwerk" },
  { value: "reporting", label: "Melding" },
  { value: "mechanical", label: "Mechanisch" },
  { value: "dependency", label: "Afhankelijkheid" },
  { value: "other", label: "Overig" },
];

export const TECHNICAL_DIAGRAM_TYPE_OPTIONS = [
  { value: "site", label: "Terrein" },
  { value: "floor", label: "Plattegrond" },
  { value: "vertical", label: "Verticaal" },
  { value: "schematic", label: "Schematisch" },
  { value: "location", label: "Locatie" },
  { value: "installation", label: "Installatie" },
  { value: "system", label: "Systeem" },
  { value: "custom", label: "Vrij" },
];

export const SITE_BUILDING_TYPE_OPTIONS = [
  { value: "main_building", label: "Hoofdgebouw" },
  { value: "garage", label: "Garage" },
  { value: "annex", label: "Bijgebouw" },
  { value: "shed", label: "Schuur" },
  { value: "technical_building", label: "Technisch gebouw" },
  { value: "other", label: "Overig" },
];

export const BUILDING_LEVEL_TYPE_OPTIONS = [
  { value: "basement", label: "Kelder" },
  { value: "parking", label: "Parkeren" },
  { value: "ground", label: "Begane grond" },
  { value: "floor", label: "Verdieping" },
  { value: "mezzanine", label: "Vide" },
  { value: "roof", label: "Dak" },
  { value: "technical", label: "Technische laag" },
  { value: "other", label: "Overig" },
];

export const BUILDING_LEVEL_CREATE_MODE_OPTIONS = [
  { value: "empty", label: "Leeg" },
  { value: "copy_building", label: "Kopie BAG-contour" },
  { value: "copy_previous", label: "Kopie vorige verdieping" },
];

export const DISTRIBUTION_BOARD_CIRCUIT_STATUS_OPTIONS = [
  { value: "in_use", label: "In gebruik" },
  { value: "reserved", label: "Gereserveerd" },
  { value: "free", label: "Vrij" },
  { value: "out_of_service", label: "Buiten gebruik" },
  { value: "defective", label: "Defect" },
  { value: "unknown", label: "Onbekend" },
];

export const DISTRIBUTION_BOARD_CIRCUIT_PHASE_OPTIONS = [
  { value: "L1", label: "L1" },
  { value: "L2", label: "L2" },
  { value: "L3", label: "L3" },
  { value: "L1L2L3", label: "3-fase" },
  { value: "unknown", label: "Onbekend" },
];

export async function listTechnicalAssets(params = {}, options = {}) {
  const res = await api.get("/assets", {
    params,
    ...buildPlatformTenantConfig(options),
  });
  return res.data;
}

export async function createTechnicalAsset(payload, options = {}) {
  const res = await api.post("/assets", payload, buildPlatformTenantConfig(options));
  return res.data;
}

export async function updateTechnicalAsset(assetId, payload, options = {}) {
  const res = await api.put(
    `/assets/${assetId}`,
    payload,
    buildPlatformTenantConfig(options)
  );
  return res.data;
}

export async function previewTechnicalAssetTag(params = {}, options = {}) {
  const res = await api.get("/assets/tag-preview", {
    params,
    ...buildPlatformTenantConfig(options),
  });
  return res.data;
}

export async function listAssetLocationNodes(params = {}, options = {}) {
  const res = await api.get("/assets/location-nodes", {
    params,
    ...buildPlatformTenantConfig(options),
  });
  return res.data;
}

export async function listAssetConnections(params = {}, options = {}) {
  const res = await api.get("/asset-connections", {
    params,
    ...buildPlatformTenantConfig(options),
  });
  return res.data;
}

export async function listConnectionsForAsset(assetId, params = {}, options = {}) {
  const res = await api.get(`/assets/${assetId}/connections`, {
    params,
    ...buildPlatformTenantConfig(options),
  });
  return res.data;
}

export async function createAssetConnection(payload, options = {}) {
  const res = await api.post(
    "/asset-connections",
    payload,
    buildPlatformTenantConfig(options)
  );
  return res.data;
}

export async function archiveAssetConnection(connectionId, options = {}) {
  const res = await api.delete(
    `/asset-connections/${connectionId}`,
    buildPlatformTenantConfig(options)
  );
  return res.data;
}

export async function listAssetDiagrams(params = {}, options = {}) {
  const res = await api.get("/asset-diagrams", {
    params,
    ...buildPlatformTenantConfig(options),
  });
  return res.data;
}

export async function createAssetDiagram(payload, options = {}) {
  const res = await api.post(
    "/asset-diagrams",
    payload,
    buildPlatformTenantConfig(options)
  );
  return res.data;
}

export async function updateAssetDiagram(diagramId, payload, options = {}) {
  const res = await api.put(
    `/asset-diagrams/${diagramId}`,
    payload,
    buildPlatformTenantConfig(options)
  );
  return res.data;
}

export async function archiveAssetDiagram(diagramId, options = {}) {
  const res = await api.delete(
    `/asset-diagrams/${diagramId}`,
    buildPlatformTenantConfig(options)
  );
  return res.data;
}

export async function enrichProjectLocation(projectId, payload, options = {}) {
  const res = await api.post(
    `/site-spatial/projects/${projectId}/enrichment`,
    payload,
    buildPlatformTenantConfig(options)
  );
  return res.data;
}

export async function listSiteBuildings(params = {}, options = {}) {
  const res = await api.get("/site-spatial/buildings", {
    params,
    ...buildPlatformTenantConfig(options),
  });
  return res.data;
}

export async function createSiteBuilding(payload, options = {}) {
  const res = await api.post(
    "/site-spatial/buildings",
    payload,
    buildPlatformTenantConfig(options)
  );
  return res.data;
}

export async function updateSiteBuilding(buildingId, payload, options = {}) {
  const res = await api.put(
    `/site-spatial/buildings/${buildingId}`,
    payload,
    buildPlatformTenantConfig(options)
  );
  return res.data;
}

export async function archiveSiteBuilding(buildingId, options = {}) {
  const res = await api.delete(
    `/site-spatial/buildings/${buildingId}`,
    buildPlatformTenantConfig(options)
  );
  return res.data;
}

export async function listBuildingLevels(params = {}, options = {}) {
  const res = await api.get("/site-spatial/levels", {
    params,
    ...buildPlatformTenantConfig(options),
  });
  return res.data;
}

export async function createBuildingLevel(payload, options = {}) {
  const res = await api.post(
    "/site-spatial/levels",
    payload,
    buildPlatformTenantConfig(options)
  );
  return res.data;
}

export async function updateBuildingLevel(levelId, payload, options = {}) {
  const res = await api.put(
    `/site-spatial/levels/${levelId}`,
    payload,
    buildPlatformTenantConfig(options)
  );
  return res.data;
}

export async function archiveBuildingLevel(levelId, options = {}) {
  const res = await api.delete(
    `/site-spatial/levels/${levelId}`,
    buildPlatformTenantConfig(options)
  );
  return res.data;
}

export async function listTechnicalInstallations(params = {}, options = {}) {
  const res = await api.get("/technical-installations", {
    params,
    ...buildPlatformTenantConfig(options),
  });
  return res.data;
}

export async function createTechnicalInstallation(payload, options = {}) {
  const res = await api.post(
    "/technical-installations",
    payload,
    buildPlatformTenantConfig(options)
  );
  return res.data;
}

export async function updateTechnicalInstallation(installationId, payload, options = {}) {
  const res = await api.put(
    `/technical-installations/${installationId}`,
    payload,
    buildPlatformTenantConfig(options)
  );
  return res.data;
}

export async function archiveTechnicalInstallation(installationId, options = {}) {
  const res = await api.delete(
    `/technical-installations/${installationId}`,
    buildPlatformTenantConfig(options)
  );
  return res.data;
}

export async function listDistributionBoardCircuits(params = {}, options = {}) {
  const res = await api.get("/distribution-board-circuits", {
    params,
    ...buildPlatformTenantConfig(options),
  });
  return res.data;
}

export async function createDistributionBoardCircuit(payload, options = {}) {
  const res = await api.post(
    "/distribution-board-circuits",
    payload,
    buildPlatformTenantConfig(options)
  );
  return res.data;
}

export async function updateDistributionBoardCircuit(circuitId, payload, options = {}) {
  const res = await api.put(
    `/distribution-board-circuits/${circuitId}`,
    payload,
    buildPlatformTenantConfig(options)
  );
  return res.data;
}

export async function archiveDistributionBoardCircuit(circuitId, options = {}) {
  const res = await api.delete(
    `/distribution-board-circuits/${circuitId}`,
    buildPlatformTenantConfig(options)
  );
  return res.data;
}
